
  var _styles = {
  "list-container": {
    "width": "100%"
  },
  "list-container--invalid": {
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "center",
    "width": "100%"
  },
  "list-container--success-vertical": {
    "display": "flex",
    "flexDirection": "row",
    "flexWrap": "wrap",
    "paddingTop": 0,
    "paddingRight": "0.32rem",
    "paddingBottom": 0,
    "paddingLeft": "0.32rem",
    "justifyContent": "space-between"
  },
  "list-container--success-horizontal": {
    "height": "4.76rem",
    "paddingLeft": "0.32rem"
  },
  "list-container__item--vertical": {
    "marginBottom": "0.32rem"
  },
  "list-container__item--horizontal": {
    "marginRight": "0.21333rem"
  }
};



  module.exports = _styles;
  